import React, {useContext, useEffect, useState} from "react";
import {getCustomerPurchaseGroupResponse, getKioskPurchaseGroupResponse} from "../../common/api/WebApi";
import ModalLoading from "../ModalLoading";
import {formatCurrency} from "../Utils";
import {CONSTANTS} from "../constants";
import MDButton from "../../../components/MDButton";
import {printOrder} from "../api/CustomerProfileApi";
import {AppContext} from "../../../lib/AppContext";


export default function CartSuccess({clientGuid, paymentId, callback, paymentMethod}) {
  const [context, setContext] = useContext(AppContext);
  const [searchTimer, setSearchTimer] = useState(1);
  const [salesReady, setSalesReady] = useState(false);
  const [salesResp, setSalesResp] = useState();

  const retryCounter = paymentMethod?.square ? 75 : 30;
  const retryInterval = paymentMethod?.square ? (1000 * 5) : 1000;

  useEffect(() => {
    const timer = setTimeout(() => {
      if (paymentId) {
        if (searchTimer > 1) {
          if (searchTimer < retryCounter) {
            if (clientGuid) {
              getSalesFn(clientGuid, paymentId);
            } else {
              getGuestSalesFn(paymentId);
            }
          } else {
            // navigate('#/cx/my-purchases');
          }
        }
      }
    }, retryInterval);
    return () => clearTimeout(searchTimer);
  }, [searchTimer]);

  const getGuestSalesFn = async (paymentId) => {
    let result = await getKioskPurchaseGroupResponse(paymentId);
    if (result) {
      if (result?.salesItems?.length > 0) {
        setSalesResp(result);
        setSalesReady(true);
        callback('CHECKOUT_SUCCESS_CONFIRMATION', result);
      } else {
        setSearchTimer(searchTimer + 1);
      }
    }
  }

  const getSalesFn = async (clientGuid, paymentId) => {
    let result = await getCustomerPurchaseGroupResponse(clientGuid, paymentId);
    if (result) {
      if (result?.salesItems?.length > 0) {
        setSalesResp(result);
        setSalesReady(true);
        callback('CHECKOUT_SUCCESS_CONFIRMATION', result);
        let c = {...context};
        c.refresh = true;
        setContext({...c});
      } else {
        setSearchTimer(searchTimer + 1);
      }
    }
  }

  useEffect(() => {
    if (paymentId) {
      if (clientGuid) {
        getSalesFn(clientGuid, paymentId);
      } else {
        getGuestSalesFn(paymentId);
      }
    }
  }, [clientGuid, paymentId]);

  return (
    <div>
      {!salesReady && <><h5
        className={'text-center'}>
        {paymentMethod?.square ? 'See Terminal to finalize Payment' : 'Hang tight, finalizing Purchase'}
      </h5><ModalLoading/></>}
      {salesReady && <><h5
        className={'text-center'}>
        {paymentMethod?.chargeTypeId === CONSTANTS.CHARGE_TYPE.INVOICE ? 'Invoice' : 'Payment'}&nbsp;complete!
      </h5>

        {salesResp && salesResp?.salesItems?.length > 0 &&
          <>
            <table className="table table-striped mt-2">
              <thead>
              <tr>
                <th scope="col">Item Name</th>
                <th scope="col" className="text-right">Item Price</th>
                <th scope="col" className="text-right">Tax</th>
                <th scope="col" className="text-right">Total</th>
              </tr>
              </thead>
              <tbody>

              {salesResp && salesResp?.salesItems?.sort((a, b) => a.id > b.id ? 1 : -1)
                .map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.itemName}</td>
                      <td className="text-right">{formatCurrency(item.total - item.salesTax)}</td>
                      <td className="text-right">{formatCurrency(item.salesTax)}</td>
                      <td className="text-right">{formatCurrency(item.total)}</td>
                    </tr>
                  )
                })
              }

              </tbody>
              <tfoot>

              <tr>
                <td scope="col"></td>
                <td scope="col"></td>
                <td scope="col" className="text-right">Subtotal:</td>
                <td scope="col" className="text-right">{formatCurrency(salesResp.totalSales - salesResp.totalTax)}</td>
              </tr>

              <tr>
                <td scope="col"></td>
                <td scope="col"></td>
                <td scope="col" className="text-right">Tax:</td>
                <td scope="col" className="text-right">{formatCurrency(salesResp.totalTax)}</td>
              </tr>

              {salesResp.serviceCharge > 0 &&
                <tr>
                  <td scope="col"></td>
                  <td scope="col"></td>
                  <td scope="col" className="text-right">Processing Fee:</td>
                  <td scope="col" className="text-right">{formatCurrency(salesResp.serviceCharge)}</td>
                </tr>
              }
              {salesResp.totalTips > 0 &&
                <tr>
                  <td scope="col"></td>
                  <td scope="col"></td>
                  <td scope="col" className="text-right">Tips:</td>
                  <td scope="col" className="text-right">{formatCurrency(salesResp.totalTips)}</td>
                </tr>
              }
              {salesResp.appliedGiftCardTotal > 0 &&
                <tr>
                  <td scope="col"></td>
                  <td scope="col"></td>
                  <td scope="col" className="text-right">Gift Card Applied:</td>
                  <td scope="col" className="text-right">({formatCurrency(salesResp.appliedGiftCardTotal)})</td>
                </tr>
              }
              <tr>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"
                    className="text-right">{paymentMethod?.chargeTypeId === CONSTANTS.CHARGE_TYPE.INVOICE && 'Invoice '}Total:
                </th>
                <th scope="col"
                    className="text-right">
                  {formatCurrency(salesResp.totalSales + salesResp.serviceCharge + salesResp.totalTips - (salesResp.appliedGiftCardTotal ? salesResp.appliedGiftCardTotal : 0))}</th>
              </tr>

              </tfoot>
            </table>
            {salesResp?.extPurchaseId && <>
              <MDButton
                color="primary"
                size={"small"}
                className={'mx-2 my-2 pull-right'}
                onClick={() => {
                  printOrder(salesResp?.extPurchaseId).then((resp) => {
                    let _context = {...context};
                    _context.toast = {
                      message: 'See Printer For Confirmation',
                    }
                    setContext({..._context});
                  })
                }}>
                Print Receipt
              </MDButton>
            </>}
          </>
        }
      </>}
    </div>


  );
}